import Swiper from "swiper";
import {
    Autoplay,
    Controller, EffectFade,
    Navigation,
    Pagination,
} from "swiper/modules";

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/controller';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import {ready} from "../utils/ready";

ready(() => {
    const pageBanner = document.querySelector('#page-banner');
    if (!pageBanner) {
        return;
    }

    const sharedOptions = {
        loop: true,
        effect: 'fade',
        modules: [
          Controller,
          EffectFade,
        ],
    }

    const imageSwiper = new Swiper('.swiper--image', {
        ...sharedOptions,
    });

    const contentSwiper = new Swiper('.swiper--content', {
        ...sharedOptions,
        modules: [
          ...sharedOptions.modules,
          Autoplay,
          Navigation,
          Pagination,
        ],
        navigation: {
            prevEl: pageBanner.querySelector('.button-prev'),
            nextEl: pageBanner.querySelector('.button-next'),
        },
        pagination: {
            el: pageBanner.querySelector('.pagination'),
            clickable: true,
        },
    });

    if (contentSwiper && imageSwiper) {
        contentSwiper.controller.control = imageSwiper;
        imageSwiper.controller.control = contentSwiper;
    }

});
